import {CompetitorFormHelper} from "@model";
import {Pipe, PipeTransform} from "@angular/core";
import {FormGroup} from "@angular/forms";

@Pipe({
    name: 'customFieldValuesFormGroup',
    standalone: false
})
export class CustomFieldValuesFormGroupPipe implements PipeTransform {
    transform(formHelper: CompetitorFormHelper, formGroup: FormGroup): FormGroup {
        return formHelper.customFieldValuesFormGroup(formGroup);
    }
}


